<template>
  <div>
    <span>{{dictLabel}}</span>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      dict: {
        type: String,
        default: null
      },
      value: {
        type: [Number, String],
        default: null
      },
    },
    computed: {
      ...mapState(['common']),
      dictLabel() {
        var dictLabel = "";
        this.common.dict.get(this.dict).forEach((item, i) => {
          if (item.value === this.value) {
            dictLabel = item.label;
          }
        })
        
        return dictLabel;
      }
    },
    created() {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?17878583